module.exports = __webpack_public_path__ + "static/media/tg_ads.903b999c.svg";